var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"box"},_vm._l((_vm.kenkaku),function(k,index){return _c('div',{key:index},[_c('browse-build',{attrs:{"gaiyo":k}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }